export const FETCH_EXAM_METRICS_MATRIX_REQUEST = 'FETCH_EXAM_METRICS_MATRIX_REQUEST';
export const FETCH_EXAM_METRICS_MATRIX_SUCCESS = 'FETCH_EXAM_METRICS_MATRIX_SUCCESS';
export const FETCH_EXAM_METRICS_MATRIX_FAILURE = 'FETCH_EXAM_METRICS_MATRIX_FAILURE';

export const EXPORT_EXAM_METRICS_MATRIX_REQUEST = 'EXPORT_EXAM_METRICS_MATRIX_REQUEST';
export const EXPORT_EXAM_METRICS_MATRIX_SUCCESS = 'EXPORT_EXAM_METRICS_MATRIX_SUCCESS';
export const EXPORT_EXAM_METRICS_MATRIX_FAILURE = 'EXPORT_EXAM_METRICS_MATRIX_FAILURE';

export const CLEAR_EXAM_METRICS_DATA = 'CLEAR_EXAM_METRICS_DATA';

export const FETCH_EXAM_METRICS_DROPDOWN_REQUEST = 'FETCH_EXAM_METRICS_DROPDOWN_REQUEST';
export const FETCH_EXAM_METRICS_DROPDOWN_SUCCESS = 'FETCH_EXAM_METRICS_DROPDOWN_SUCCESS';
export const FETCH_EXAM_METRICS_DROPDOWN_FAILURE = 'FETCH_EXAM_METRICS_DROPDOWN_FAILURE';

export const FETCH_EXAM_METRICS_DATE_RANGE_REQUEST = 'FETCH_EXAM_METRICS_DATE_RANGE_REQUEST';
export const FETCH_EXAM_METRICS_DATE_RANGE_SUCCESS = 'FETCH_EXAM_METRICS_DATE_RANGE_SUCCESS';
export const FETCH_EXAM_METRICS_DATE_RANGE_FAILURE = 'FETCH_EXAM_METRICS_DATE_RANGE_FAILURE';
